export default [{
  path: '/penalty-reasons',
  name: 'penalty_reasons',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/penaltyReasons/index')
}]
